import { Terrain } from './terrain';

export class Plain extends Terrain {
    constructor(parameters) {
        super(parameters);
    }

    static name = 'Plain'
}